// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.duplicate-config-alert_root__i7r1U {
  background: var(--mui-palette-secondary-200);
  border-radius: 8px;
  padding: 16px;
  font-size: 14px;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}`, "",{"version":3,"sources":["webpack://./src/components/most/list/scheduled-jobs/form/duplicate-config-alert/index.module.css"],"names":[],"mappings":"AAAA;EACE,4CAA4C;EAC5C,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB","sourcesContent":[".root {\n  background: var(--mui-palette-secondary-200);\n  border-radius: 8px;\n  padding: 16px;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  margin-bottom: 16px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `duplicate-config-alert_root__i7r1U`
};
export default ___CSS_LOADER_EXPORT___;
